import { keyframes } from '@mui/material';

export const ButtonCommonStyle = {
  width: '200px',
  position: 'relative',
  right: 0,
  left: 0,
  margin: '0 auto',
  textDecoration: 'none',
  marginBottom: '20px',
  borderRadius: '6px',
  padding: '10px 0',
  fontSize: '0.9em',
  display: 'block',
  textAlign: 'center',
  transition: 'all 0.3s ease',
  cursor: 'pointer',
  color: '#fff',
};

export const InputStyle = {
  display: 'block',
  width: '100%',
  height: 'calc(1.5em + 0.75rem + 2px)',
  padding: '0.375rem 0.75rem',
  fontSize: '1rem',
  fontWeight: 400,
  lineHeight: 1.5,
  color: '#495057',
  backgroundColor: '#fff',
  backgroundClip: 'padding-box',
  border: '1px solid #ced4da',
  borderRadius: '0.25rem',
  transition: ' border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
};

export const ListItemStyle = ({
  text,
  active,
  openedMenuColor,
}: {
  text?: string;
  active?: string;
  openedMenuColor?: string;
}) => ({
  fontSize: '1em',
  width: '100%',
  padding: '8px 23px',
  color: text ? text : '#fff',
  borderLeft: '2px solid transparent',
  position: 'relative',
  margin: '0 auto',
  transition: 'color 0.3s ease',
  lineHeight: 1.4,
  cursor: 'pointer',
  backgroundColor: openedMenuColor || '',
  '&:hover': {
    backgroundColor: active || '',
  },
});

export const NavStyle = (menuOpen?: boolean, fon?: string) => ({
  position: 'absolute',
  right: menuOpen ? '0' : '-250px',
  width: '250px',
  minHeight: '150px',
  top: '20px',
  zIndex: 110,
  transition: 'all 0.3s ease',
  paddingTop: '20px',
  background: fon ? fon : 'rgba(0, 0, 0, 0.6)',
  borderTopLeftRadius: '8px',
  borderBottomLeftRadius: '8px',
});

export const SearchInputStyle = {
  height: '40px',
  borderRadius: '7px',
  background: 'rgba(248, 248, 248, 0.5)',
  color: 'white',
  marginTop: 0,
  padding: 0,
  fontFamily: 'Heebo, sans-serif !important',
  border: 'none',
  outline: 'none',
  '&::placeholder': {
    color: 'var(--color-primary)',
    fontSize: '16px',
  },
};

export const CloseButtonStyle = {
  position: 'absolute',
  left: '155px',
  top: '10px',
  color: 'rgba(0, 0, 0, 0.6)',
  '&:hover': {
    color: 'rgba(0, 0, 0, 1)',
  },
};

export const SearchButtonStyle = (searchButtonColor?: string) => ({
  background: searchButtonColor ? searchButtonColor : 'var(--color-secondary)',
  color: '#fff',
  border: 0,
  borderRadius: '0 7px 7px 0',
  width: '40px',
  height: '40px',
});

export const MenuGeaderStyle = (textColor?: string) => ({
  color: textColor || '#fff',
  fontSize: '1.1em',
  fontWeight: 'normal',
  fontStyle: 'normal',
  marginLeft: '25px',
  marginBottom: '30px',
  textTransform: 'uppercase',
});

export const AddressBoxStyle = {
  display: 'block',
  color: '#fff',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  width: ' 100%',
  fontSize: '12px',
  marginBottom: '20px',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
};

export const HintBoxStyle = {
  position: 'absolute',
  zIndex: 1,
  width: 'max-content',
  background: 'rgba(0, 0, 0, 0.8)',
  color: 'white',
  padding: '8px',
  borderRadius: '20px',
  top: '7px',
  right: '70px',
  whiteSpace: 'nowrap',
};

export const CloseHintIconStyle = {
  background: 'var(--color-secondary)',
  color: 'white',
  borderRadius: '50%',
  fontSize: '10px !important',
  padding: '8px',
  margin: '1px 8px',
  '&:hover': {
    background: 'white',
    color: 'var(--color-secondary)',
  },
};

export const HintArrowStyle = {
  background: 'white',
  color: 'rgba(0, 0, 0, 0.8)',
  borderRadius: '50%',
  fontSize: '10px !important',
  padding: '3px',
  marginLeft: '10px',
};

const expand = keyframes`
0% {
  transform: scale(1);
}
50% {
  transform: scale(1.1);
}
100% {
  transform: scale(1);
}
`;

export const ToggleNavBoxStyle = (showExpand, fon) => ({
  position: 'relative',
  padding: '13px',
  borderTopLeftRadius: '28px',
  borderBottomLeftRadius: '28px',
  top: 0,
  right: 0,
  display: 'block',
  marginBottom: '10px',
  background: fon || 'rgba(0, 0, 0, 0.6)',
  animation: showExpand ? `${expand} 2s infinite` : '',
});

export const ToggleNavButtonStyle = {
  padding: 0,
  minWidth: 'unset',
  display: 'inline-block',
  cursor: 'pointer',
  transitionProperty: 'opacity, filter',
  transitionDuration: '0.15s',
  transitionTimingFunction: 'linear',
  font: 'inherit',
  color: 'inherit',
  textTransform: 'none',
  backgroundColor: 'transparent',
  border: 0,
  margin: 0,
  overflow: 'visible',
  '&:hover': {
    opacity: 0.7,
    backgroundColor: 'transparent',
  },
};

export const SearchButtonSpanStyle = (menuOpen: boolean, searchButtonColor?: string) => ({
  display: 'block',
  top: '50%',
  marginTop: '-1px',
  backgroundColor: searchButtonColor ? searchButtonColor + '!important' : '#fff',
  transform: menuOpen ? 'rotate(225deg)' : 'unset',
  transitionDelay: menuOpen ? '0.12s' : 'unset',

  '&, &::before,&::after': {
    content: "''",
    display: 'block',
    width: '20px',
    height: '2px',
    backgroundColor: searchButtonColor ? searchButtonColor + '!important' : '#fff',
    borderRadius: '4px',
    position: 'absolute',
    transitionProperty: 'transform',
    transitionDuration: '0.15s',
    transitionTimingFunction: 'ease',
  },
  '&::before': {
    top: menuOpen ? 0 : '-6px',
    opacity: menuOpen ? 0 : 1,

    transition: menuOpen
      ? 'top 0.1s ease-out, opacity 0.1s 0.12s ease-out'
      : ' top 0.1s 0.25s ease-in, opacity 0.1s ease-in',
  },

  '&::after': {
    bottom: menuOpen ? 0 : '-6px',
    transform: menuOpen ? 'rotate(-90deg)' : 'unset',

    transition: menuOpen
      ? 'bottom 0.1s ease-out, transform 0.22s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1)'
      : 'bottom 0.1s 0.25s ease-in, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19)',
  },
  transitionDuration: '0.22s',
  transitionTimingFunction: menuOpen
    ? 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    : 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
});
